import React, {useEffect, useState} from 'react';
import {MultiSelectComponent, MultiSelectOption} from "module/CustomField/component/input/MultiSelectComponent";
import {CustomFieldTO} from 'generated/JavaTO'
import {getDqParamsObject} from 'module/CustomField/util/DqParam'
import {CFModel} from 'module/CustomField/type/CFType'
import {searchDq} from 'module/Dq/searchDq'
import {serverErrorHandler} from 'module/ConfirmDialog/component/ConfirmDialogContainer'

interface Props<T> {
	modelValue: T
	disabled?: boolean
	setCb: (val: T) => void
	cfDef: CustomFieldTO
	model: CFModel
	pos?: number
}

type PossibleValues = string | number | null | undefined

export function DqRadioComponent(props: Props<PossibleValues>) {
	const [options, setOptions] = useState<MultiSelectOption<PossibleValues>[]>([])
	const dqkey = props.cfDef.dqKey
	const params = getDqParamsObject(props.cfDef.dqParams, props.model, props.pos)
	useEffect(() => {
		searchDq({dqkey, params}).then((data) => {
			setOptions(data.map(x => ({isButton: true, displayName: x.label, value: x.value})) as MultiSelectOption<PossibleValues>[])
		}).catch(serverErrorHandler)
	}, [dqkey, ...Object.values(params)])
	return <MultiSelectComponent {...props} options={options}/>;
}